module.exports = __webpack_public_path__ + "media/images/symbols/paul-singh-group-logo-caf4c2558fb4454943df944409f63003.svg";